import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-page">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="lg:ml-[250px] min-h-screen flex flex-col">
        <Topbar onToggleSidebar={() => setSidebarOpen((open) => !open)} />

        <main className="flex-1 px-3 md:px-6 py-4 md:py-6">
          <div className="page-card">
            <div className="p-4 md:p-6">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
